<!-- @format -->

@let errors = productErrors();

<div class="fulfillment-section hmf-p-s hmf-display-flex hmf-flex-column">
	@defer (when !isLoading() && !isLoadingFulfillment()) {
		<span class="fulfillment-section-label hmf-body-s hmf-mb-xxs">Fulfillment</span>
		@if (errors.length) {
			<span class="hmf-body-bold-m hmf-text-align-center hmf-p-xxs empty-fulfillment">-</span>
		} @else {
			<common-product-availability
				class="hmf-body-bold-s hmf-body-bold-sm-m"
				[productAvailabilityData]="
					compareProductsAvailability().ecodeMessagingMap[productEcode()]
				"
				[selectedStoreName]="userStoreInfo()?.name"
				[showStoreNameInMessage]="true"
				(clickSelectedStoreName)="openStoreDrawer()"
				>
			</common-product-availability>
		}
	} @placeholder {
		<compare-components-skeleton-fulfillment-section>
		</compare-components-skeleton-fulfillment-section>
	}
</div>
